const setOutdated = () => ({ type: 'UPDATES_SET_OUTDATED' });

export default setOutdated;
